export default {
  routes: [
    {
      name: 'templates',
      path: '/directory/templates',
      component: () => import('./views/TheTemplates.vue'),

    },

    {
      name: 'template',
      path: '/directory/templates/:uuid',
      component: () => import('./views/TheTemplate.vue'),
    },
  ]
}
